export const defaultValues: Record<string, string> = {
    feedback_name: 'EQUIPMENT_DETAIL_FEEDBACK_NAME_NO_DEFAULT',
    id_defaut_list: 'LIST_OF_LAST_10_DEFAULTS_NO_DEFAULT',
    window_sensed_panel: 'EQUIPMENT_WINDOW_SENSED_PANEL_255',
};
